export default (that) => [
  {
    text: that.$l('btn_view_details') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
    allow: 'SQ',
  },
  {
    text: that.$l('btn_edit_product') || '编辑产品',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'SM',
    disabled: ({ hxSkuStatus, applicationStatus }) => {
      return !!(
        that.disabled ||
        ['D'].includes(hxSkuStatus) ||
        (applicationStatus && ['P'].includes(applicationStatus))
      )
    },
  },
  {
    text: that.$l('btn_delete_product') || '删除产品',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'SD',
    disabled: ({ hxSkuStatus, applicationStatus }) => {
      return !!(
        that.disabled ||
        !['Q'].includes(hxSkuStatus) ||
        (applicationStatus && ['P'].includes(applicationStatus))
      )
    },
  },
  {
    text: that.$l('btn_copy_sku') || '复制产品',
    icon: 'el-icon-document-copy',
    menuType: 'copy',
    allow: 'SE',
    disabled: ({ hxSkuStatus }) => {
      return hxSkuStatus == 'D' ||
        that.disabled
    },
  },
  {
    text: that.$l('btn_full_member') || '转正产品',
    icon: 'el-icon-circle-check',
    menuType: 'fullMember',
    allow: 'SF',
    divided: true,
    disabled: ({ hxSkuStatus }) => {
      return that.disabled || !['Q'].includes(hxSkuStatus)
    },
  },
]
